const EventStyle = {
  card: {
    border: '1px solid gray',
    padding: '10px',
    margin: '7px'
  }
}

export default EventStyle
